import FIlterChart from "./FIlterChart";

const PerformanceReport = () => {
  return <FIlterChart />;
};
export default PerformanceReport;
